import { useConsole } from "contexts/Console"
import Quote from "./Quote"

export default function QuoteTextEnd(props) {
  const console = useConsole()

  console.log("TestimoneeQuoteTextEnd(%o)", props)

  return <Quote {...props} text_end />
}
